"use client";
import { marketplaceOptions } from "@/shared/constants";
import FilterIcon from "@/assets/icons/filter.svg";
import { MultipleSelectDropdownInput } from "@/app/(components)/Basic/MultiSelectDropdownInput";
import { OptionPicker } from "@/app/(components)/Basic/DropdownInputBase/types";
export interface Props {
  containerClassName?: string;
  marketplaces: string[];
  setMarketplaces: (marketplaces: string[]) => void;
}

const MarketplaceFilter = ({
  containerClassName,
  marketplaces,
  setMarketplaces,
}: Props) => {
  const onFilterSearch = (options: string[]) => {
    setMarketplaces(options);
  };

  return (
    <MultipleSelectDropdownInput
      startIcon={<FilterIcon className="w-5 h-5" />}
      selectedOption={marketplaces}
      setSelectedOption={onFilterSearch}
      options={marketplaceOptions}
      childrenClassName="w-[350px]"
      label={
        <>
          <span className="font-light mr-1">Marketplace:</span>
          {marketplaces.length > 1
            ? `${marketplaces.filter((opt: any) => opt !== "selectAll").length} selected`
            : marketplaceOptions.find((opt) => opt.value === marketplaces[0])
                ?.label}
        </>
      }
      optionPicker={OptionPicker.CHECKBOX}
      className="w-[350px]"
      containerClassName={containerClassName}
    />
  );
};

export default MarketplaceFilter;
